import React, { useState } from 'react'
import './App.css'
import { ModalForm, NavBar, TableList } from '@/components'
import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

function App() {
  const [isOpen, setIsOpen] = useState(false)
  const [mode, setMode] = useState('create')
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedClient, setSelectedClient] = useState(null)
  const [updateTrigger, setUpdateTrigger] = useState(0)

  const handleOpen = (mode, client = null) => {
    setMode(mode)
    setSelectedClient(client)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    setSelectedClient(null)
  }

  const handleSubmit = async (clientData) => {
    try {
      if (mode === 'edit' && selectedClient) {
        await axios.put(`${API_URL}/api/clients/${selectedClient.id}`, clientData)
      } else {
        await axios.post(`${API_URL}/api/clients`, clientData)
      }
      setUpdateTrigger(prev => prev + 1)
      handleClose()
    } catch (error) {
      console.error('Error submitting client:', error)
    }
  }

  return (
    <div className="container mx-auto px-4">
      <NavBar onOpen={() => handleOpen('create')} onSearch={setSearchTerm} />
      <TableList 
        handleOpen={handleOpen} 
        searchTerm={searchTerm} 
        updateTrigger={updateTrigger}
      />
      <ModalForm
        isOpen={isOpen}
        onClose={handleClose}
        mode={mode}
        OnSubmit={handleSubmit}
        clientData={selectedClient}
      />
    </div>
  )
}

export default App
